"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewTakeOff = function NewTakeOff() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "17",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.5 16.5V15.0001H18.5V16.5H1.5ZM3.06153 11.952L0.5 7.56356L1.70383 7.32126L3.47307\n8.87126L8.4173 7.53278L4.3673 0.682784L5.87497 0.217407L12.725 6.34818L17.6769 5.02703C18.1333\n4.90267 18.5461 4.98824 18.9153 5.28376C19.2846 5.57926 19.4692 5.9706 19.4692 6.45778C19.4692\n6.77315 19.3759 7.05007 19.1894 7.28853C19.0028 7.52698 18.7602 7.6898 18.4615 7.77698L3.06153\n11.952Z",
    fill: "#6E6D71"
  }));
};
var _default = NewTakeOff;
exports.default = _default;